import $axios from '~/plugins/axios';
import { Api, File } from '~/api';
import { buildModule } from '../utils';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedFiles: {} as Dict<File>,
		uploadedFileId: null as number | null,
		uploadedFileIds: [] as number[],
	})
	.withGetters({
		storedFiles: state => state.storedFiles,
		byId: state => (fileId: number) => state.storedFiles[fileId],
		uploadedFileIds: state => state.uploadedFileIds,
		uploadedFileId: state => state.uploadedFileIds[state.uploadedFileIds.length - 1],
	})
	.withMutations({
		STORE_FILE (state, file: File) {
			state.storedFiles = {
				...state.storedFiles,
				[file.id]: file,
			};
		},
		RESET_UPLOADED_FILE_IDS (state) {
			state.uploadedFileIds = [];
		},
		ADD_UPLOADED_FILE_ID (state, fileId: number) {
			state.uploadedFileIds = [ ...state.uploadedFileIds, fileId ];
		},
	})
	.withActions({
		async upload ({ commit }, formData: FormData) {
			const { data } = await api.post('/file', formData);
			commit('STORE_FILE', data.payload);
			commit('ADD_UPLOADED_FILE_ID', data.payload.id);
			return data.payload.id;
		},
		async get ({ commit }, fileId: number) {
			const { data } = await api.get(`/file/${ fileId }`);
			commit('STORE_FILE', data.payload);
		},
	});
